import { processListingParams } from '@/api/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { getExceptionFromAxiosError } from '../helpers';
import {
  CreateLongLivedTokenRequest,
  ListLongLivedTokensRequest,
  SaveTokenResponse,
  TokensListResponse,
  UpdateLongLivedTokenRequest,
} from './types';

export const longLivedTokenService = (client: AxiosInstance) => {
  const createToken = async (
    accountId: string,
    request: CreateLongLivedTokenRequest,
  ): Promise<SaveTokenResponse> => {
    try {
      const result = await client.post<
        SaveTokenResponse,
        AxiosResponse<SaveTokenResponse>
      >(`/accounts/${accountId}/long-lived-tokens`, request, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const updateToken = async (
    accountId: string,
    tokenId: string,
    request: UpdateLongLivedTokenRequest,
  ): Promise<SaveTokenResponse> => {
    try {
      const result = await client.patch<
        SaveTokenResponse,
        AxiosResponse<SaveTokenResponse>
      >(`/accounts/${accountId}/long-lived-tokens/${tokenId}`, request, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const getTokens = async (
    accountId: string,
    params: ListLongLivedTokensRequest,
  ): Promise<TokensListResponse> => {
    try {
      const result = await client.get<
        TokensListResponse,
        AxiosResponse<TokensListResponse>
      >(`/accounts/${accountId}/long-lived-tokens`, {
        withCredentials: true,
        params: processListingParams(params),
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const deleteToken = async (accountId: string, tokenId: string) => {
    try {
      await client.delete(
        `/accounts/${accountId}/long-lived-tokens/${tokenId}`,
        {
          withCredentials: true,
        },
      );
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    createToken,
    updateToken,
    getTokens,
    deleteToken,
  };
};
